/* ===== LUMA VISION THEME JS v4.0 ===== */
document.addEventListener('DOMContentLoaded', function () {

  /* ── Mobile menu ── */
  var menuBtn = document.querySelector('.mobile-menu-btn');
  var mobileNav = document.querySelector('.mobile-nav');
  var mobileClose = document.querySelector('.mobile-nav-close');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', function () {
      mobileNav.classList.add('open');
      menuBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    });
    if (mobileClose) {
      mobileClose.addEventListener('click', function () {
        mobileNav.classList.remove('open');
        menuBtn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    }
    mobileNav.addEventListener('click', function (e) {
      if (e.target === mobileNav) {
        mobileNav.classList.remove('open');
        menuBtn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
    });
  }

  /* ── FAQ accordion ── */
  document.querySelectorAll('.faq-question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = this.closest('.faq-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function (el) { el.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

  /* ── Product gallery thumbs ── */
  document.querySelectorAll('.product-gallery-thumbs img').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.querySelector('.product-gallery-main img');
      if (mainImg) {
        mainImg.src = this.src.replace('_200x200', '_800x800');
        document.querySelectorAll('.product-gallery-thumbs img').forEach(function (t) { t.classList.remove('active'); });
        this.classList.add('active');
      }
    });
  });

  /* ── Cart count ── */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = data.item_count;
          el.style.display = data.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(function () {});
  }
  updateCartCount();

  /* ── Add to Cart (product page) ── */
  var addBtn = document.querySelector('.product-add-btn');
  if (addBtn) {
    addBtn.addEventListener('click', function () {
      var variantId = this.dataset.variantId;
      if (!variantId) return;
      var originalText = this.textContent;
      this.textContent = 'Adding…';
      this.classList.add('loading');
      this.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          addBtn.textContent = '✓ Added to Cart';
          addBtn.classList.remove('loading');
          addBtn.disabled = false;
          updateCartCount();
          setTimeout(function () {
            addBtn.textContent = originalText;
          }, 2500);
        })
        .catch(function () {
          addBtn.textContent = 'Error — Try Again';
          addBtn.classList.remove('loading');
          addBtn.disabled = false;
          setTimeout(function () { addBtn.textContent = originalText; }, 2500);
        });
    });
  }

  /* ── Checkout button on product page ── */
  var checkoutBtn = document.querySelector('.product-checkout-btn');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function () {
      var variantId = this.dataset.variantId;
      if (!variantId) { window.location.href = '/cart'; return; }
      this.textContent = 'Redirecting…';
      this.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function () {
          window.location.href = '/cart';
        });
    });
  }

  /* ── Hero / CTA "Add to Cart" buttons → goes to cart ── */
  document.querySelectorAll('.hero-buy-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = this.dataset.variantId;
      if (!variantId) { window.location.href = '/collections/all'; return; }
      var original = this.textContent;
      this.textContent = 'Adding…';
      this.disabled = true;
      var self = this;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function () {
          self.textContent = original;
          self.disabled = false;
        });
    });
  });

  /* ── Hide mobile CTA bar when user is at top (hero visible) ── */
  var mobileCta = document.querySelector('.mobile-cta-bar');
  if (mobileCta) {
    function onScroll() {
      if (window.scrollY < 300) {
        mobileCta.setAttribute('aria-hidden', 'true');
        mobileCta.style.transform = 'translateY(100%)';
      } else {
        mobileCta.setAttribute('aria-hidden', 'false');
        mobileCta.style.transform = 'translateY(0)';
      }
    }
    mobileCta.style.transition = 'transform 0.3s ease';
    mobileCta.style.transform = 'translateY(100%)';
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── Cart qty +/- ── */
  document.addEventListener('click', function (e) {
    if (e.target.classList.contains('qty-inc') || e.target.classList.contains('qty-dec')) {
      var wrap = e.target.closest('.cart-qty');
      if (!wrap) return;
      var span = wrap.querySelector('span');
      if (!span) return;
      var qty = parseInt(span.textContent, 10) || 1;
      if (e.target.classList.contains('qty-inc')) qty = Math.min(qty + 1, 99);
      if (e.target.classList.contains('qty-dec')) qty = Math.max(qty - 1, 1);
      span.textContent = qty;
    }
  });

  /* ── Smooth scroll ── */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (mobileNav) {
          mobileNav.classList.remove('open');
          document.body.style.overflow = '';
        }
      }
    });
  });

});
